import { useEffect, useState } from "react";
import { storage } from "../firebase";
import { ref, listAll, getDownloadURL } from "firebase/storage";

import "../styles/sponzori.css";
import download from "../assets/download.svg";
import Button from "../components/Button";

const YEARS = [2025, 2024]; // Add or remove years as needed
const SPONSOR_ORDER = ["RealizacijskiPartneri", "Generalni", "Platinum", "Gold"];

function Sponzori() {
  const [selectedYear, setSelectedYear] = useState(2024); // default year
  const [pictures, setPictures] = useState([]);

  const getSponsorManual = async () => {
    const fileRef = ref(storage, "dokumenti/sponzorski_paket.pdf");
    try {
      const url = await getDownloadURL(fileRef);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sponzorski_paket.pdf";
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSponsors(selectedYear);
  }, [selectedYear]);

  const fetchSponsors = async (year) => {
    const yearRef = ref(storage, `sponzori/${year}`);
    const response = await listAll(yearRef);

    // Sort folders based on defined order
    const sortedFolders = response.prefixes.sort((a, b) => SPONSOR_ORDER.indexOf(a.name) - SPONSOR_ORDER.indexOf(b.name));

    const fetched = await Promise.all(
      sortedFolders.map(async (folderRef) => {
        const images = await getImages(folderRef);
        return {
          name: folderRef.name,
          images,
        };
      })
    );

    setPictures(fetched);
  };

  const getImages = async (folderRef) => {
    const res = await listAll(folderRef);
    const urls = await Promise.all(res.items.map((item) => getDownloadURL(item)));
    return urls;
  };

  return (
    <>
      <div className="year-bar">
        {YEARS.map((year) => (
          <span key={year} onClick={() => setSelectedYear(year)} className={`year-item ${year === selectedYear ? "active" : ""}`}>
            {year}
          </span>
        ))}
      </div>

      <div className="section column">
        <div className="wrapper">
          {pictures.map(
            (obj, i) =>
              obj.images.length > 0 && (
                <div key={i}>
                  <h1 className="title">
                    {obj.name === "RealizacijskiPartneri"
                      ? "Realizacijski Partneri"
                      : obj.name === "Generalni"
                      ? "Generalni sponzor"
                      : obj.name}
                  </h1>
                  <div className="divider" />
                  <div className="sponsor-grid">
                    {obj.images.map((img, index) => (
                      <img key={index} className="sponsor-icon" src={img} alt="sponsor logo" loading="lazy" />
                    ))}
                  </div>
                </div>
              )
          )}
        </div>
      </div>

      {/* Sponsor Info Section */}
      <div className="section column big-gap">
        <h1 className="title centered">Želiš postati sponzor?</h1>
        <h2 className="subtitle centered">Radujemo se svakoj suradnji!</h2>
        <div className="text centered">
          Preuzmite naš sponzorski paket i provjerite što nudimo. Ako ste zainteresirani za sponzorstvo, javite nam se na naš{" "}
          <a id="mail" href="/kontakt">
            mail
          </a>
          .
        </div>
        <Button onClick={getSponsorManual} text={"Preuzmi PDF"} icon={download} />
      </div>
    </>
  );
}

export default Sponzori;
